import {adminHttp} from "~/Admin/services/http";
import tokenStorage from "~/services/tokenStorage";
import {ADMIN_AUTH_TOKEN} from "~/Admin/services/http/adminAxios";

export const loadUserAction = () => async (dispatch) => {

    const userResponse = await adminHttp.get('/auth/me');

    dispatch({
        type: 'LOAD_USER',
        payload: userResponse.data || null
    });
};

export const loginAction = (email, password) => async (dispatch) => {

    const body = {
        email: email,
        password: password,
    };

    try {
        const res = await adminHttp.post('/auth/login', body);

        let token = res.data?.token;

        tokenStorage.setItem(ADMIN_AUTH_TOKEN, token);

        dispatch(loadUserAction());
        return res;

    } catch (error) {

        dispatch({
            type: 'LOGIN_FAIL',
        });

        return error.response;
    }
};

export const logoutAction = () => (dispatch) => {
    tokenStorage.removeItem(ADMIN_AUTH_TOKEN);
    localStorage.removeItem('adminCurrentEvent');
    dispatch({type: 'LOGOUT'});
};
